function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.66663H2.33333H13",
  stroke: "#6F9EFB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.33301 3.66667V2.33333C4.33301 1.97971 4.47348 1.64057 4.72353 1.39052C4.97358 1.14048 5.31272 1 5.66634 1H8.33301C8.68663 1 9.02577 1.14048 9.27582 1.39052C9.52587 1.64057 9.66634 1.97971 9.66634 2.33333V3.66667M11.6663 3.66667V13C11.6663 13.3536 11.5259 13.6928 11.2758 13.9428C11.0258 14.1929 10.6866 14.3333 10.333 14.3333H3.66634C3.31272 14.3333 2.97358 14.1929 2.72353 13.9428C2.47348 13.6928 2.33301 13.3536 2.33301 13V3.66667H11.6663Z",
  stroke: "#6F9EFB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33301 7V11",
  stroke: "#6F9EFB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.6665 7V11",
  stroke: "#6F9EFB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDeleteCalendarsPrimary = function SvgDeleteCalendarsPrimary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteCalendarsPrimary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-calendars-primary.72bc7a05.svg";
export { ForwardRef as ReactComponent };